import { render, staticRenderFns } from "./PreRegisAddSubject.vue?vue&type=template&id=28c21f2c&scoped=true"
import script from "./PreRegisAddSubject.vue?vue&type=script&lang=js"
export * from "./PreRegisAddSubject.vue?vue&type=script&lang=js"
import style0 from "./PreRegisAddSubject.vue?vue&type=style&index=0&id=28c21f2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c21f2c",
  null
  
)

export default component.exports